/**
 * SelectInput component
 */

// React
import React, { FC, useState } from 'react';

// Libraries
import { useNavigate } from 'react-router-dom';
import { useResetRecoilState, useSetRecoilState } from 'recoil';

// Material
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { SxProps } from '@mui/material/styles';

// Recoil
import { paramsGetListAtom } from 'recoil/ParamsGetListRecoil';

// Utils
import { VALUE_MENU } from 'utils/constants';
import { MenuItems, MenuItemValue } from 'utils/types';

// Common styles
import { WrapperSelectInput } from 'styles';

// Recoil
import { notifyAtom } from 'recoil/NotifyRecoil';

// Type
type SelectInputProps = {
  defaultValue?: MenuItemValue;
  menuItems: MenuItems<MenuItemValue>;
  height?: string;
  sx?: SxProps;
  sxSelect?: SxProps;
  sxSelectItem?: SxProps;
};

// Component
const SelectInput: FC<SelectInputProps> = ({
  defaultValue = VALUE_MENU.USER_INFO,
  sxSelect = { height: 48, fontSize: '20px' },
  menuItems,
  sx = { width: 320, mb: '60px' },
  sxSelectItem = { padding: '10px', fontSize: '16px' },
}) => {
  const resetParamsGetUsers = useResetRecoilState(paramsGetListAtom);
  const setNotify = useSetRecoilState(notifyAtom);
  const [value, setValue] = useState<any>(defaultValue);
  const navigate = useNavigate();

  const handleChange = (event: SelectChangeEvent<any>) => {
    setValue(event.target.value as any);
  };

  const handleClick = (href?: string) => {
    if (href) {
      resetParamsGetUsers();
      setNotify({ open: false });
      navigate(href);
    }
  };

  return (
    <WrapperSelectInput sx={sx}>
      <FormControl fullWidth variant="outlined">
        <Select
          defaultValue={VALUE_MENU.USER_INFO}
          value={value}
          onChange={handleChange}
          displayEmpty
          sx={sxSelect}
        >
          {menuItems?.map((item, index) => (
            <MenuItem
              sx={sxSelectItem}
              key={index}
              value={item?.value}
              onClick={() => handleClick(item?.href)}
            >
              {item?.content}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </WrapperSelectInput>
  );
};

export default SelectInput;
